<ion-grid [fixed]="true">
  @if(!isUploading()) {
  <ion-row>
    <ion-col>
      <div class="drag-drop-wrap">
        <ion-text color="dark" class="primary-text"
          ><h4>{{ "UPLOAD.TITLE" | translate }}</h4></ion-text
        >
        <ion-text color="medium" class="secondary-text"
          ><h5>{{ "UPLOAD.FORMAT" | translate }} {{ allowedFilesSizeInMb }}MB</h5></ion-text
        >
        <input
          #fileInput
          class="ion-hide"
          type="file"
          multiple
          [accept]="allowedFileTypesForInput()"
          (change)="onFileSelected($event)" />
        <ion-button shape="round" color="primary" (click)="fileInput.click()">
          <ion-icon slot="start" color="light" name="cloud-upload-outline"> </ion-icon>

          <ion-text color="light">{{ "UPLOAD.BUTTON" | translate }}</ion-text>
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="shouldShowFileTypeHintMessage()">
    <ion-col>
      <ion-text color="medium">
        <h5>
          <ion-icon name="information-circle-outline" color="primary"></ion-icon>
          <span>{{ "UPLOAD.ONLY-PDF" | translate }}</span>
        </h5>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isCertificate()">
    <ion-col>
      <ion-text color="medium">
        <h5>
          <ion-icon name="information-circle-outline" color="primary"></ion-icon>
          <span>{{ "UPLOAD.CERTIFICATE_ONLY_ONE_PAGE" | translate }}</span>
        </h5>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    @for (selectedFile of selectedFiles(); track $index) {
    <ion-col size="12">
      <div class="file-card-wrap">
        <div>
          <div class="file-row-wrap">
            <ion-icon class="large" [name]="getSelectedFileIcon(selectedFile)" color="primary"> </ion-icon>
            <div class="file-name-wrap">
              <ion-text color="dark">
                <h4 class="file-name-wrap__primary-text">
                  {{ selectedFile.name }}
                </h4>
              </ion-text>
              <ion-text color="medium"
                ><h5 class="file-name-wrap__secondary-text">{{ selectedFile.size }} MB</h5>
              </ion-text>
            </div>
          </div>
          <div class="file-copies-wrap" *ngIf="!isCertificateOrBusinessCard()">
            <ion-text color="dark">
              <h4 class="file-name-wrap__primary-text">{{ "UPLOAD.COPIES" | translate }}:</h4>
            </ion-text>
            <div class="stepper">
              <ion-button
                color="primary"
                fill="clear"
                (click)="decreaseCopies(selectedFile)"
                [disabled]="selectedFile.copies <= 1">
                <ion-icon name="remove-outline"></ion-icon>
              </ion-button>

              <ion-text class="stepper-value">
                {{ selectedFile.copies }}
              </ion-text>

              <ion-button
                color="primary"
                fill="clear"
                (click)="increaseCopies(selectedFile)"
                [disabled]="selectedFile.copies >= 50">
                <ion-icon name="add-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
        <div class="file-delete-wrap" (click)="onFileRemove(selectedFile)">
          <ion-icon class="large file-row-wrap__delete" name="close-outline" color="danger"> </ion-icon>
        </div>
      </div>
    </ion-col>
    }
  </ion-row>
  <ion-row *ngIf="isCertificateOrBusinessCard() && selectedFilesQuantity() > 0">
    <div class="file-copies-wrap">
      <ion-text color="dark">
        <h4 class="file-name-wrap__primary-text">{{ "UPLOAD.COPIES" | translate }}:</h4>
      </ion-text>
      <div class="stepper">
        <ion-button
          color="primary"
          fill="clear"
          (click)="decreaseGeneralCopies()"
          [disabled]="generalNumberOfCopies() <= 1">
          <ion-icon name="remove-outline"></ion-icon>
        </ion-button>

        <ion-text class="stepper-value">
          {{ generalNumberOfCopies() }}
        </ion-text>

        <ion-button
          color="primary"
          fill="clear"
          (click)="increaseGeneralCopies()"
          [disabled]="generalNumberOfCopies() >= 50">
          <ion-icon name="add-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-row>
  } @else {
  <ion-row>
    <ion-col>
      <div class="spinner-wrap">
        <ion-spinner color="primary" name="crescent" mode="md"></ion-spinner>
        <ion-text>
          <h3 class="spinner-wrap__wait-text">{{ "UPLOAD.WAIT" | translate }}</h3>
        </ion-text>
        <ion-text color="success">
          <h3>{{ progress() }}%</h3>
        </ion-text>
      </div>
    </ion-col>
  </ion-row>
  }
</ion-grid>
